<div class="section-header" >
  <div class="d-flex">
    <div class="w-100">
    <div class="container">
      <span class="h2">Cos'è il Centro Funzionale Multirischi ?</span>
    </div>
    </div>
  </div>
</div>

<div class="wrapper">
  <div class="section-about-us">
    <div class="container">
      <p class="descrizioneSezione" [innerHTML]="descrizioneSezione">
      </p>
    </div>
  </div>
  <div class="gradient-section p-3">
  <div class="container sede-wrapper">
    <div class="card w-100" style="height: 500px">
      <div class="w-100 h-100 sede-container">
        <div class="col-md-3 col-sm-12 d-flex flex-column justify-content-end p-4">
            <div><h4><strong>Centro Funzionale Multirischi</strong></h4></div>
            <div><h5>Protezione Civile <br> Regione Campania</h5></div>
            <div><p>Centro Direzionale<br>
            Isola C3<br>
            80143 - Napoli</p></div>
        </div>
        <div class="map-container col-sm-12 col-md-9">
          <div id="mapSede" class="w-100 h-100" style="height: 100%; width: 70%;"></div>
        </div>
      </div>
    </div>
  </div>
</div>
  
<div class="section-about-us mb-3">
    <div class="pt-5 d-flex justify-content-center">
      
        <!-- Tabs with Background on Card -->
          <div class="nav-tabs-navigation" data-tabs-color="orange">
            <div class="nav-tabs-wrapper">
              <ngb-tabset [justify]="'center'" class="text-center">
                <ngb-tab title="Contatti">
                  <ng-template ngbTabContent>
                    <div class="container my-4">
                      <div class="row g-3">
                        <!-- Card contatti -->
                        <div class="col-md-6 col-12 mb-3" *ngFor="let contatto of listaContatti" style="min-height: 50%;">
                          <div class=" h-100 w-100 p-3 bg-light border rounded">
                            <h5 class="fw-bold">{{getRuoloDescrizione(contatto.idTipoContatti)}}</h5>
                            <p class="mb-0"><strong>{{contatto.nome}} </strong></p>
                            <p class="mb-0">Tel: {{contatto.telefono}} </p>
                            <!-- <p class="mb-0">Tel 2: {{contatto.cellulare}} </p>   -->
                            <p class="mb-0">Email: 
                              <a class="linkclass" href="mailto:{{contatto.email}}">{{contatto.email}}</a>
                            </p>
                            <p class="mb-0" *ngIf="contatto.pec">Pec: 
                              <a class="linkclass" href="mailto:{{contatto.pec}}">{{contatto.pec}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-tab>
                <ngb-tab title="Organigramma">
                  <ng-template ngbTabContent>
                    <div class="container my-4">
                      <div class="row g-3">
                        <!-- Card organigramma -->
                        <div class="col-12 mb-3" *ngFor="let organi of organigrammaList;">
                          <div class="p-3 bg-light border rounded">
                            <h5 class="fw-bold">{{getRuoloOrganigramma(organi.idOrganigramma)}}</h5>
                            <div *ngFor="let membri of organi.elements;">
                              <span *ngIf="membri.nome"><b>{{membri.nome}}</b></span>
                              <span *ngIf="membri.competenza"> | {{membri.competenza}}</span>
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-tab>
              </ngb-tabset>
            </div>
          </div>
        

    </div>
  </div>
</div>